// import mqtt from "mqtt";

// var mqttClient = (function () {
//     var instance;
//     function init() {
//         var connection = null;
//         return {
//             setConnection: function (connection_options) {
//                 let { host, port, endpoint, ...options } = connection_options;
//                 let connectUrl = `wss://${host}:${port}${endpoint}`;
//                 connection = mqtt.connect(connectUrl, options);
//             },
//             getConnection: function () {
//                 return connection;
//             }
//         };
//     }

//     return {
//         getInstance: function () {
//             if (!instance) instance = init();
//             return instance;
//         }
//     }
// })();

// export default mqttClient;


import mqtt from "mqtt";

var mqttClient = (function () {
    "use strict";
    var connection; //prevent modification of "connection" variable
    function Singleton(connectUrl, options) {
        if (connection) {
            return connection;
        }
        connection = this;
        //Singleton initialization code
        connection = mqtt.connect(connectUrl, options);
        return connection;
    }
    // Instance accessor
    Singleton.getInstance = function (connectUrl, options) {
        return connection || new Singleton(connectUrl, options);
    }
    return Singleton;
}());

export default mqttClient;